import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const Ctx = createContext(null);
const KEY = 'barterfi:selectedDepartment';

export function DepartmentProvider({ children }) {
  const [selected, setSelected] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
  });
  useEffect(() => {
    if (selected) localStorage.setItem(KEY, JSON.stringify(selected));
    else localStorage.removeItem(KEY);
  }, [selected]);
  const value = useMemo(() => ({ selected, setSelected }), [selected]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useDepartment() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useDepartment must be used within DepartmentProvider');
  return ctx;
}
